import React from "react";
import { Utils } from "../../common/utils";
import { FormRow, Input } from "../../components";
import { type GetSetValueProp } from "../models";

const PerPageInput = (props: GetSetValueProp<string>) => {
  const isNumber = parseInt(props.value, 10);
  const hasError = Number.isNaN(isNumber);

  const onChange = (_: any, { value }: { value: string }) => {
    props.setValue(value);
  };

  const onBlur = () => {
    const numberValue = Number.parseInt(props.value, 10);
    if (!Number.isNaN(numberValue)) {
      props.setValue(Utils.clamp(numberValue, 5, 50).toString());
    }
  };

  return <FormRow label={RESX.EmbedWizard.PerPage}>
    <Input
      onBlur={onBlur}
      error={hasError}
      value={props.value}
      onChange={onChange}
      style={{ width: 45 }}
      maxLength={3}
      label={RESX.Show.Shows}
      labelPosition="right"
    />
  </FormRow>;
};

export default PerPageInput;